const Component = () => import('./SupplierPortal');

export { Component };
